import { useVentures } from "@/hooks/use-mock-data";
import { Button } from "@/components/ui/button";
import { Plus, Github, ExternalLink } from "lucide-react";

const statusColors: Record<string, string> = {
  planning: "#555555",
  building: "#EBF216",
  launched: "#4B75F2",
  growing: "#44F2D2",
  sunset: "#CC2936",
};

export default function VenturesPage() {
  const { data: ventures } = useVentures();

  return (
    <div className="animate-fade-in max-w-7xl mx-auto px-6 py-6">
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-brand text-4xl tracking-wide">VENTURE PORTFOLIO</h1>
        <Button className="bg-electric-blue hover:bg-electric-blue/90 text-white text-xs uppercase tracking-wider">
          <Plus className="w-4 h-4 mr-1" /> Add Venture
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {ventures.map((venture) => {
          const color = statusColors[venture.status] ?? "#555555";
          return (
            <div
              key={venture.id}
              className="glass-card rounded-lg p-4 card-hover"
              style={{ borderLeft: `3px solid ${color}` }}
            >
              <div className="flex items-center justify-between mb-2">
                <h3 className="text-foreground font-medium">{venture.name}</h3>
                <span
                  className="text-[9px] uppercase tracking-wider px-1.5 py-0.5 rounded font-brand"
                  style={{ color, backgroundColor: `${color}12` }}
                >
                  {venture.status}
                </span>
              </div>
              <p className="text-xs text-muted-foreground mb-3 line-clamp-2">{venture.description}</p>
              <div className="flex items-center justify-between text-xs">
                <span className="font-mono text-foreground">
                  ${venture.monthlyRevenue.toLocaleString("en-US", { minimumFractionDigits: 2 })}
                  <span className="text-muted-foreground">/mo</span>
                </span>
                {venture.launchDate && (
                  <span className="text-muted-foreground">
                    Launched {new Date(venture.launchDate).toLocaleDateString("en-US", { month: "short", year: "numeric" })}
                  </span>
                )}
              </div>
              <div className="flex gap-2 mt-3">
                {venture.githubUrl && (
                  <a href={venture.githubUrl} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground">
                    <Github className="w-4 h-4" />
                  </a>
                )}
                {venture.liveUrl && (
                  <a href={venture.liveUrl} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground">
                    <ExternalLink className="w-4 h-4" />
                  </a>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
